<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_MagInspect">
        <span class="col-form-label">Are you able to inspect the parts under magnification?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_TestDots">
        <span class="col-form-label">Do the parts contain test dots?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_VisibleDirt">
        <span class="col-form-label">Are the parts dirty?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_VisibleDust">
        <span class="col-form-label">Do the parts show any signs of dust, sand or any other residue?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_ImproperHandling">
        <span class="col-form-label">Are there any signs of improper handling or storage?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_ConsistentDCLC">
        <span class="col-form-label">Are all date/lot codes marked consistently?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_SameOrigin">
        <span
          class="col-form-label"
        >Is the Country of Origin consistent on all parts of the same date/lot code?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_ClearMfrLogo">
        <span class="col-form-label">Is the MFR logo clearly noted on the component?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_PartsProperPosition">
        <span class="col-form-label">Are all parts in the proper position/alignment in the carrier? (Reel, Tray, Tube)</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_CracksScratch">
        <span
          class="col-form-label"
        >Is there any evidence of cracks, scratches, chips or other visual non-conformities?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_SameSurfaces">
        <span class="col-form-label">Does the surface appear consistent on all components?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_SurfaceSanding">
        <span
          class="col-form-label"
        >Does the surface show any signs of sanding or do you see ridges in the surface?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_ClearPN">
        <span class="col-form-label">Are the part numbers clearly visible?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_SamePN">
        <span
          class="col-form-label"
        >Is the part number printed consistently, is it straight and in the same location on all parts?</span>
      </b-form-radio-group>

      <b-form-radio-group
        :options="['Laser Marked', 'Printed', 'N/A']"
        v-model="model.surface_MarkedOrPrinted"
      >
        <span
          class="col-form-label"
        >Is the part number laser-marked on the part or does it appear to be printed?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_TopBottomMarkings">
        <span
          class="col-form-label"
        >Can you inspect top and bottom markings?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_SamePinIndicator">
        <span class="col-form-label">Is the pin indicator in the correct/same location on all parts?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_PhotosTaken">
        <span class="col-form-label">Were digital photos taken of the part?</span>
      </b-form-radio-group>

      <b-form-group label="Any notes/non-compliances">
        <b-textarea type="text" v-model="model.surface_NonComplianceNotes"></b-textarea>
      </b-form-group>

      <!-- <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.surface_PhotosTaken">
        <span class="col-form-label">Include any non-compliances</span>
      </b-form-radio-group> -->
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'aegisSurface',
  components: {},
  props: {
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        surface_MagInspect: this.inspectionDetails[FIELDS.SURFACE__MAG_INSPECT] || '',
        surface_TestDots: this.inspectionDetails[FIELDS.SURFACE__TEST_DOTS] || '',
        surface_VisibleDirt: this.inspectionDetails[FIELDS.SURFACE__VISIBLE_DIRT] || '',
        surface_VisibleDust: this.inspectionDetails[FIELDS.SURFACE__VISIBLE_DUST] || '',
        surface_ImproperHandling: this.inspectionDetails[FIELDS.SURFACE__IMPROPER_HANDLING] || '',
        surface_ConsistentDCLC: this.inspectionDetails[FIELDS.SURFACE__CONSISTENT_DCLC] || '',
        surface_SameOrigin: this.inspectionDetails[FIELDS.SURFACE__SAME_ORIGIN] || '',
        surface_ClearMfrLogo: this.inspectionDetails[FIELDS.SURFACE__CLEAR_MFR_LOGO] || '',
        surface_CracksScratch: this.inspectionDetails[FIELDS.SURFACE__CRACKS_SCRATCH] || '',
        surface_SameSurfaces: this.inspectionDetails[FIELDS.SURFACE__SAME_SURFACES] || '',
        surface_TopBottomMarkings: this.inspectionDetails[FIELDS.SURFACE__TOP_BOTTOM_MARKINGS] || '',
        surface_SamePinIndicator: this.inspectionDetails[FIELDS.SURFACE__SAME_PIN_INDICATOR] || '',
        surface_PhotosTaken: this.inspectionDetails[FIELDS.SURFACE__PHOTOS_TAKEN] || '',
        surface_SurfaceSanding: this.inspectionDetails[FIELDS.SURFACE__SURFACE_SANDING] || '',
        surface_ClearPN: this.inspectionDetails[FIELDS.SURFACE__CLEAR_PN] || '',
        surface_SamePN: this.inspectionDetails[FIELDS.SURFACE__SAME_PN] || '',
        surface_MarkedOrPrinted: this.inspectionDetails[FIELDS.SURFACE__MARKED_OR_PRINTED] || '',
        surface_PartsProperPosition: this.inspectionDetails[FIELDS.SURFACE__PARTS_PROPER_POSITION] || '',
        surface_NonComplianceNotes: this.inspectionDetails[FIELDS.SURFACE__NON_COMPLIANCE_NOTES] || '',
        
      },
    };
  },
  computed: {},
  mounted() {},
};
</script>